<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <!--summary cash report list-->
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Choose Shop..."
                item-text="name"
                item-value="id"
                v-model="queryParams.shopIds"
                multiple
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete 
                :items="currencyList" 
                label="Choose Currency..."
                color="blue-grey lighten-2" 
                item-text="code" 
                item-value="id" 
                menu-props="auto" 
                v-model="queryParams.currencyId"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <!--summary amount--->
            <v-flex xs12>
              <v-card class="font-weight-bold">
                <v-card-title class="blue darken-3">
                  <span class="headline white--text">Summary</span>
                </v-card-title>
                <v-card-text class="font-weight-bold">
                  <div>
                    <v-btn
                      color="primary"
                      :loading="buttonLoading"
                      @click="printAllCashReport('printCashReport')"
                      >PRINT ALL</v-btn
                    >
                    <v-btn
                      color="success"
                      :loading="buttonLoading"
                      @click="exportAllCashReport()"
                      >EXPORT ALL</v-btn
                    >
                  </div>
                  <div>
                    <span>Total Credit Sale(Cash Receive) Amount:</span>
                    <v-chip
                      ><span>{{
                        totalCreditIncomeAmount | decFormat
                      }}</span></v-chip
                    >
                    <span>Total Cash Sale Amount:</span>
                    <v-chip>
                      <span>{{ totalCashIncomeAmount | decFormat }}</span>
                    </v-chip>
                    <span>Total Computer Sale Amount:</span>
                    <v-chip
                      ><span>{{
                        totalComputerSaleAmount | decFormat
                      }}</span></v-chip
                    >
                    <span>Total Different Amount:</span>
                    <v-chip
                      ><span>{{
                        totalDifferentAmount | decFormat
                      }}</span></v-chip
                    >
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
            <!--end summary amount--->
            <!--summary list--->
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="cashReportList"
                  class="elevation-1"
                  :loading="showListLoading"
                  :total-items="totalRows"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :must-sort="true"
                >
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td>{{ props.item.shopName }}</td>
                      <td style="text-align: right">{{ props.item.creditIncomeAmount | decFormat }}</td>
                      <td style="text-align: right">{{ props.item.cashIncomeAmount | decFormat }}</td>
                      <td style="text-align: right">{{ props.item.computerSaleAmount | decFormat }}</td>
                      <td style="text-align: right">{{ props.item.differentAmount | decFormat }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
            <!--end summary list--->
          </v-layout>
        </v-card>
      </v-flex>
      <!--end summary cash report list-->

      <!--real cash income amount detail list-->
      <v-flex xs12>
        <br />
        <div class="text-xs-left">Real Cash Income Amount Details</div>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="realCashIncomeHeaders"
            :items="realCashIncomeDetailList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="realCashInTotalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="realCashInPagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.shopName }}</td>
                <td v-if="props.item.type == 'CASH_SALE'">{{ props.item.type }}</td>
                <td v-else>{{ props.item.type }} (CASH RECEIVE)</td>
                <td style="text-align: right">{{ props.item.cashAmount | decFormat }}</td>
                <td style="text-align: right">{{ props.item.kpayAmount | decFormat }}</td>
                <td style="text-align: right">{{ props.item.bankTransferAmount | decFormat }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <!--end real cash income amount detail list-->

      <!--computer sale amount detail list-->
      <v-flex xs12>
        <br />
        <div class="text-xs-left">Computer Sale Amount Details</div>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="computerSaleHeaders"
            :items="computerSaleDetailList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="computerSaleTotalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="computerSalePagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.shopName }}</td>
                <td style="text-align: right">{{ props.item.retailSaleAmount | decFormat }}</td>
                <td style="text-align: right">{{ props.item.wholeSaleAmount | decFormat }}</td>
                <td style="text-align: right">{{ props.item.creditReceiveAmount | decFormat }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <!--end computer sale amount detail list-->
    </v-layout>

    <!--print all-->
    <div
      id="printCashReport"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Cash Report</p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <br />
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 1px">
          Total Credit Sale(Cash Receive) Amount : {{
            printTotalCreditIncomeAmount | decFormat
          }}
        </p>
      </div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 1px">
          Total Cash Sale Amount : {{
            printTotalCashIncomeAmount | decFormat
          }}
        </p>
      </div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 1px">
          Total Computer Sale Amount : {{
            printTotalComputerSaleAmount | decFormat
          }}
        </p>
      </div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 1px">
          Total Different Amount : {{
            printTotalDifferentAmount | decFormat
          }}
        </p>
      </div>
      <!--cash report table -->
      <table
        style="
          font-family: arial, sans-serif;
          border-collapse: collapse;
          width: 100%;
          font-size: 11px;
        "
      >
        <thead
          style="border-bottom: 1px solid black; border-top: 1px solid black"
        >
          <tr>
            <th style="text-align: left">Shop</th>
            <th style="text-align: right">Credit Sale(Cash Receive) Amount</th>
            <th style="text-align: right">Cash Sale Amount</th>
            <th style="text-align: right">Total Computer Sale Amount</th>
            <th style="text-align: right">Different Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in allCashReportList"
            :key="index"
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <td style="text-align: left">{{ item.shopName }}</td>
            <td style="text-align: right">
              {{ item.creditIncomeAmount | decFormat }}
            </td>
            <td style="text-align: right">
              {{ item.cashIncomeAmount | decFormat }}
            </td>
            <td style="text-align: right">
              {{ item.computerSaleAmount | decFormat }}
            </td>
            <td style="text-align: right">
              {{ item.differentAmount | decFormat }}
            </td>
          </tr>
        </tbody>
      </table>
      <!--end cash report table -->

      <div style="height: 10px"></div>
      <div style="height: 10px"></div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 0px">
          Real Cash Income Amount Details
        </p>
      </div>
      <!--real cash income amount detail table -->
      <table
        style="
          font-family: arial, sans-serif;
          border-collapse: collapse;
          width: 100%;
          font-size: 11px;
        "
      >
        <thead
          style="border-bottom: 1px solid black; border-top: 1px solid black"
        >
          <tr>
            <th style="text-align: left">Shop</th>
            <th style="text-align: left">Type</th>
            <th style="text-align: right">Cash Amount</th>
            <th style="text-align: right">K Pay Amount</th>
            <th style="text-align: right">Bank Transfer Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in allRealCashIncomeDetailList"
            :key="index"
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <td style="text-align: left">{{ item.shopName }}</td>
            <td style="text-align: left" v-if="item.type == 'CASH_SALE'">{{ item.type }}</td>
            <td style="text-align: left" v-else>{{ item.type }} (CASH RECEIVE)</td>
            <td style="text-align: right">
              {{ item.cashAmount | decFormat }}
            </td>
            <td style="text-align: right">
              {{ item.kpayAmount | decFormat }}
            </td>
            <td style="text-align: right">
              {{ item.bankTransferAmount | decFormat }}
            </td>
          </tr>
        </tbody>
      </table>
      <!--end real cash income amount detail table -->

      <div style="height: 10px"></div>
      <div style="height: 10px"></div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 0px">Computer Sale Amount Details</p>
      </div>
      <!--computer sale amount detail table -->
      <table
        style="
          font-family: arial, sans-serif;
          border-collapse: collapse;
          width: 100%;
          font-size: 11px;
        "
      >
        <thead
          style="border-bottom: 1px solid black; border-top: 1px solid black"
        >
          <tr>
            <th style="text-align: left">Shop</th>
            <th style="text-align: right">Retail Sale Amount</th>
            <th style="text-align: right">Wholesale Amount</th>
            <th style="text-align: right">Credit Receive Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in allComputerSaleDetailList"
            :key="index"
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <td style="text-align: left">{{ item.shopName }}</td>
            <td style="text-align: right">
              {{ item.retailSaleAmount | decFormat }}
            </td>
            <td style="text-align: right">
              {{ item.wholeSaleAmount | decFormat }}
            </td>
            <td style="text-align: right">
              {{ item.creditReceiveAmount | decFormat }}
            </td>
          </tr>
        </tbody>
      </table>
      <!--end computer sale amount detail table -->
    </div>
    <!--end print all--->
  </v-container>
</template>

<script>
import { cashReportService } from "../../services/cash-report-service";
import { commonService } from "../../services/common-service";
import { shopService } from "../../services/shop-service";
import { currencyService } from "../../services/currency-service";

export default {
  name: "CashReport",
  components: {},
  data: () => ({
    buttonLoading: false,
    showListLoading: false,
    user: JSON.parse(localStorage.getItem("user")),
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Cash Report",
        disabled: true,
      },
    ],
    headers: [
      { text: "Shop", align: "left", value: "temp.shopName" },
      { text: "Credit Sale(Cash Receive) Amount", align: "right", value: "temp.creditIncomeAmount" },
      { text: "Cash Sale Amount", align: "right", value: "temp.cashIncomeAmount" },
      { text: "Total Computer Sale Amount", align: "right", value: "temp.computerSaleAmount" },
      { text: "Different Amount", align: "right", sortable: false },
    ],
    realCashIncomeHeaders: [
      { text: "Shop", align: "left", value: "sh.name" },
      { text: "Type", value: "type" },
      { text: "Cash Amount", align: "right", value: "cashAmount" },
      { text: "K Pay Amount", align: "right", value: "kpayAmount" },
      { text: "Bank Transfer Amount", align: "right", value: "bankTransferAmount" },
    ],
    computerSaleHeaders: [
      { text: "Shop", align: "left", value: "temp.shopName" },
      { text: "Retail Sale Amount", align: "right", value: "temp.retailAmount" },
      { text: "Wholesale Amount", align: "right", value: "temp.whSaleAmount" },
      { text: "Credit Receive Amount", align: "right", value: "temp.creditReceiveAmount" },
    ],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      shopIds: [],
      currencyId: ""
    },
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "temp.shopName",
      totalItems: 0
    },
    realCashInPagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "sh.name",
      totalItems: 0
    },
    computerSalePagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "temp.shopName",
      totalItems: 0
    },
    totalRows: 0,
    realCashInTotalRows: 0,
    computerSaleTotalRows: 0,
    rowsPerPageItems: [25, 50, 100],
    clonequeryParams: new Object(),
    totalCreditIncomeAmount: 0.0,
    totalCashIncomeAmount: 0.0,
    totalComputerSaleAmount: 0.0,
    totalDifferentAmount: 0.0,
    printTotalCreditIncomeAmount: 0.0,
    printTotalCashIncomeAmount: 0.0,
    printTotalComputerSaleAmount: 0.0,
    printTotalDifferentAmount: 0.0,
    shopList: [],
    cashReportList: [],
    realCashIncomeDetailList: [],
    computerSaleDetailList: [],
    allCashReportList: [],
    allRealCashIncomeDetailList: [],
    allComputerSaleDetailList: [],
    currencyList: []
  }),
  watch: {
    pagination: {
      handler() {
        this.getCashReportList();
      },
      deep: true
    },
    realCashInPagination: {
      handler() {
        this.getRealCashIncomeDetailList();
      },
      deep: true
    },
    computerSalePagination: {
      handler() {
        this.getComputerSaleDetailList();
      },
      deep: true
    }
  },
  created() {
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.shopIds) {
      this.queryParams.shopIds = this.$route.query.shopIds;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getAllshop();
    this.getActiveCurrency()
    .finally(() => {
        this.onSearch();
    });
  },
  methods: {
    getAllshop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "cash-report",
        query: this.queryParams,
      });
      this.clonequeryParams = Object.assign({}, this.queryParams);
      this.getCashReportList();
      this.getRealCashIncomeDetailList();
      this.getComputerSaleDetailList();
    },
    getCashReportList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      cashReportService
        .getCashReportList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          this.cashReportList = res.data.cashReportList;
          this.totalRows = res.data.totalElements;
          this.totalCreditIncomeAmount = res.data.totalCreditIncomeAmount;
          this.totalCashIncomeAmount = res.data.totalCashIncomeAmount;
          this.totalComputerSaleAmount = res.data.totalComputerSaleAmount;
          this.totalDifferentAmount = res.data.totalDifferentAmount;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getRealCashIncomeDetailList() {
      this.showListLoading = true;
      let order = this.realCashInPagination.descending ? "desc" : "asc";
      cashReportService
        .getRealCashIncomeDetailList(
          this.queryParams,
          this.realCashInPagination.page,
          this.realCashInPagination.rowsPerPage,
          this.realCashInPagination.sortBy + "," + order
        )
        .then((res) => {
          this.realCashIncomeDetailList = res.data.realCashIncomeList;
          this.realCashInTotalRows = res.data.totalElements;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getComputerSaleDetailList() {
      this.showListLoading = true;
      let order = this.computerSalePagination.descending ? "desc" : "asc";
      cashReportService
        .getComputerSaleDetailList(
          this.queryParams,
          this.computerSalePagination.page,
          this.computerSalePagination.rowsPerPage,
          this.computerSalePagination.sortBy + "," + order
        )
        .then((res) => {
          this.computerSaleDetailList = res.data.computerSaleList;
          this.computerSaleTotalRows = res.data.totalElements;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    printAllCashReport(divName) {
      this.buttonLoading = true;
      cashReportService
        .getCashReportListForPrint(this.clonequeryParams)
        .then((res) => {
          this.allCashReportList = res.data.cashReportList;
          this.allRealCashIncomeDetailList = res.data.realCashIncomeList;
          this.allComputerSaleDetailList = res.data.computerSaleList;
          this.printTotalCreditIncomeAmount = res.data.totalCreditIncomeAmount;
          this.printTotalCashIncomeAmount = res.data.totalCashIncomeAmount;
          this.printTotalComputerSaleAmount = res.data.totalComputerSaleAmount;
          this.printTotalDifferentAmount = res.data.totalDifferentAmount;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
    exportAllCashReport() {
      this.buttonLoading = true;
      cashReportService
        .getCashReportExcelExport(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    getActiveCurrency(){
      return currencyService.getCurrencyByStatus('ACTIVE')
      .then(res => {
        if(res.data){
          this.currencyList = res.data;
          let c = commonService.search("defaultCurrency",true,this.currencyList);
          if(c){
            this.queryParams.currencyId = c.id;
          }
        }
      })
      .catch((err) => {
        if (err.response.data) {
          this.responseError = err.responseError.data.message;
        }
      });
    }
  },
};
</script>
